'use strict';

var selectFromObject = require('./selectFromObject');

function objectSelect(obj, f) {
  return selectFromObject(obj, f, true);
}

module.exports = objectSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/object/internal/objectSelect.js
// module id = 875
// module chunks = 1